<template>
  <div>
    <page-title
      heading="Edit Data PIC"
      :breadcrumb="[
        {
          label: 'Daftar PIC Faskes',
          link: '/pic-klinik'
        },
        {
          label: 'Edit PIC',
          active: true
        }
      ]"
    />
    <template v-if="this.formData.status != 1">
      <div>
        <div class="container-fluid mb-2 no-padd">
          <div class="row justify-content-center">
            <div class="col-sm-12 ">
              <div
                class="card-body"
                style="background: #eaf0f6; padding:0.5rem;"
              >
                <b-row>
                  <b-col
                    sm="1"
                    class="text-center mt-2"
                    style="padding-right: 5px; padding-left: 5px;"
                  >
                    <font-awesome-icon
                      size="3x"
                      style="color: #5565f3; "
                      icon="clipboard-list"
                    />
                  </b-col>
                  <b-col
                    sm="10"
                    class="mt-2"
                    style="padding-left: 0px; font-size: 14px;"
                  >
                    <label style="margin-bottom:0.2rem;"
                      ><strong
                        >&#x2022; Apabila alamat email diubah, maka akan
                        dilakukan
                        <label style="color: #5565f3; "
                          >pengiriman email aktivasi ulang</label
                        >
                        ke email baru.</strong
                      ></label
                    ><br />
                    <label
                      ><strong
                        >&#x2022; Apabila status diubah menjadi
                        <label style="color: #e4413e; ">non-aktif</label>, akan
                        menyebabkan pengguna
                        <label style="color: #e4413e; "
                          >tidak dapat melakukan login.</label
                        ></strong
                      ></label
                    >
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="container-fluid">
      <div class="card card-box">
        <div class="card-body">
          <b-row>
            <b-col sm="3">
              <b-form-group style="position: relative">
                <label class="font-weight-bold">Nama PIC</label>
                <label style="color:red"> *</label>
                <b-form-input
                  v-model="formData.nama_pic"
                  maxlength="50"
                  type="text"
                  required
                  ref="nama_pic"
                />
                <template
                  v-if="formData.nama_pic == '' || formData.nama_pic == null"
                >
                  <label style="color: red">Kolom harus diisi</label>
                </template>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group style="position: relative">
                <label class="font-weight-bold">Alamat Email</label>
                <label style="color:red"> *</label>
                <b-form-input
                  v-model="formData.email"
                  maxlength="50"
                  type="text"
                  required
                  ref="email"
                  @input="cekValue($event)"
                />
                <template v-if="formData.email == '' || formData.email == null">
                  <label style="color: red">Kolom harus diisi</label>
                </template>
                <template v-else-if="failedEmail">
                  <label style="color: red">Format email salah</label>
                </template>
                <template v-else-if="!validasiNoIzin && !loadEdit">
                  <label style="color: red">Email sudah digunakan</label>
                </template>
                <template v-else-if="validasiNoIzin && !loadEdit">
                  <label style="color: #1bc943">Email dapat digunakan</label>
                </template>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group style="position: relative">
                <label class="font-weight-bold">No. Handphone</label>
                <label style="color:red"> *</label>
                <b-form-input
                  v-model="formData.telephone"
                  maxlength="15"
                  type="text"
                  required
                  ref="email"
                  @input="cekValueHP($event)"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                />
                <template
                  v-if="formData.telephone == '' || formData.telephone == null"
                >
                  <label style="color: red">Kolom harus diisi</label>
                </template>
                <template
                  v-else-if="formData.telephone.match(/[^0-9/]+/) !== null"
                >
                  <label style="color: red">Hanya bisa menulis angka</label>
                </template>
                <template v-else-if="formData.telephone.length < 10">
                  <label style="color: red"
                    >No.handphone minimal 10 karakter</label
                  >
                </template>
                <template v-else-if="!validasiNoHP && !loadEdit">
                  <label style="color: red"
                    >No. Handphone telah digunakan</label
                  >
                </template>
                <template v-else-if="validasiNoHP && !loadEdit">
                  <label style="color: #1bc943"
                    >No. Handphone dapat digunakan</label
                  >
                </template>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <b-form-group style="position: relative">
                <label class="font-weight-bold">Nama Klinik</label>
                <label style="color:red"> *</label>
                <vue-select
                  :options="faskes"
                  v-model="selectedKlinik"
                  placeholder="Pilih Jenis Klinik"
                  @input="setDataKota(selectedKlinik)"
                />
                <template v-if="selectedKlinik == '' || selectedKlinik == null">
                  <label style="color: red">Kolom harus dipilih</label>
                </template>
                <template v-else-if="klinikAvailable">
                  <label style="color: red"
                    >Klinik telah ditambahkan sebelumnya</label
                  >
                </template>
                <template v-else-if="!klinikAvailable && !loadEdit">
                  <label style="color: #1bc943">Klinik dapat digunakan</label>
                </template>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group style="position: relative">
                <label class="font-weight-bold">Kabupaten/Kota</label>
                <b-form-input
                  disabled
                  v-model="formData.kota.nama"
                  maxlength="50"
                  type="text"
                  required
                  ref="email"
                  @input="cekValue($event)"
                />
              </b-form-group>
            </b-col>
            <template v-if="formData.status != 1 && !formData.is_owner">
              <b-col sm="2">
                <b-form-group style="position: relative">
                  <label class="font-weight-bold">Account Status</label>
                  <br />
                  <b-form-checkbox v-model="accountStatus" switch>
                    <label v-html="labelStatus"></label>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </template>
            <b-col sm="6" class="offset-6 mt-5">
              <template>
                <b-button
                  class="ml-3 text-uppercase"
                  variant="primary"
                  style="font-size:17.5px;float:right;border-radius:0.65rem;"
                  @click="submitForm"
                >
                  simpan
                </b-button>
                <b-button
                  :to="{ name: 'pic-klinik-list' }"
                  class="text-uppercase"
                  variant="danger"
                  style="font-size:17.5px;float:right;border-radius:0.65rem;"
                >
                  tutup
                </b-button>
              </template>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import startCase from "lodash/startCase";
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faClipboardList,
  faEye,
  faEyeSlash,
  faLongArrowAltRight,
  faInfo,
  faCheckCircle
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faClipboardList,
  faEye,
  faInfo,
  faLongArrowAltRight,
  faEyeSlash,
  faCheckCircle
);

export default {
  data: () => ({
    beingSubmit: false,
    user_id: null,
    klinik_id: null,
    formData: {
      no_klinik: null,
      nama_pic: null,
      email: null,
      status: null,
      is_active: null,
      kota: {
        id: null,
        nama: null
      }
    },
    cities: [],
    faskes: [],
    old_email: null,
    accountStatus: null,
    selectedKlinik: null,
    klinikAvailable: false,
    selectedKota: null,
    validasiNoIzin: true,
    validasiNoHP: true,
    noIzinBefore: null,
    noHPBefore: null,
    loadEdit: true,
    labelStatus: null,
    failedEmail: false
  }),
  computed: {
    ...mapGetters(["getKlinikId"])
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
      this.$swal({
        title: startCase("keluar"),
        text: `Anda yakin untuk keluar dari halaman ini?`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  beforeRouteEnter(to, from, next) {
    const { params } = to;
    const { user_id, klinik_id } = params;
    if (!user_id && !klinik_id) {
      next({
        name: "pic-klinik-list"
      });
    } else {
      next();
    }
  },
  mounted() {
    this.user_id = this.$router.currentRoute.params.user_id;
    this.klinik_id = this.$router.currentRoute.params.klinik_id;
    this.getKlinikData();
  },
  watch: {
    accountStatus() {
      if (this.accountStatus) {
        this.formData.is_active = 1;
        this.labelStatus = `<span class="text-primary font-weight-bold">Aktif</span>`;
      } else {
        this.formData.is_active = 0;
        this.labelStatus =
          '<span class="text-danger font-weight-bold">Non-Aktif</span>';
      }
    }
  },
  components: {
    "vue-select": () => import("@/components/VueSelectClearable.vue")
  },
  methods: {
    setDataKota(val) {
      this.getPICExists(val);
    },
    async getPICExists(val) {
      try {
        const res = await this.$axios.get(
          `klinik/pic-exists/${val.id}?id_user=${this.user_id}`
        );
        const { status, data } = res.data;
        if (status || val.id == this.formData.klinik.id) {
          this.klinikAvailable = false;
          this.loadEdit = false;
          this.formData.kota.nama = data.kota_detail.nama;
        } else {
          this.klinikAvailable = true;
          this.formData.kota.nama = "";
        }
      } catch (error) {}
    },
    submitForm() {
      let err = false;
      if (this.formData.nama_pic == "" || this.formData.nama_pic == null) {
        this.$refs.nama_pic.focus();
        err = true;
      } else if (
        this.formData.email == "" ||
        this.formData.email == null ||
        !this.validasiNoIzin
      ) {
        this.$refs.email.focus();
        err = true;
      } else if (this.selectedKlinik == "" || this.selectedKlinik == null) {
        this.$refs.selectedKlinik.focus();
        window.scrollTo({
          top: 260,
          behavior: "smooth"
        });
        this.$refs.selectedKlinik.blur();
        err = true;
      } else if (
        this.formData.kota.nama == "" ||
        this.formData.kota.nama == null
      ) {
        this.$refs.kota.focus();
        window.scrollTo({
          top: 260,
          behavior: "smooth"
        });
        this.$refs.kota.blur();
        err = true;
      }

      if (err) {
        this.$swal({
          text: `Silakan cek kembali pengisian data Anda!`,
          type: "warning"
        });
      } else {
        this.beingSubmit = true;
        this.editPasien();
      }
    },
    async editPasien() {
      try {
        if (this.old_email === this.formData.email) {
          const res = await this.$axios.put(`klinik/pic`, {
            id_user: parseInt(this.user_id),
            nomor_telp: this.formData.telephone,
            nama: this.formData.nama_pic,
            email: this.formData.email,
            klinik_id_pic: parseInt(this.klinik_id),
            klinik_id_pic_after:
              typeof this.selectedKlinik === "object"
                ? this.selectedKlinik.id
                : parseInt(this.klinik_id),
            klinik_id: this.getKlinikId,
            status: this.formData.is_active
          });
          if (res.data.status === true) {
            this.$swal({
              text: `Data PIC berhasil disimpan!`,
              type: "success"
            }).then(res => {
              this.beingSubmit = true;
              this.$router.push({
                name: "pic-klinik-list"
              });
            });
          } else if (res.data.status == "failed") {
            this.$swal({
              text: `Klinik sudah memiliki PIC`,
              type: "warning",
              confirmButtonText: "OK"
            });
          } else {
            this.$swal({
              text: `Data PIC gagal disimpan!`,
              type: "warning"
            });
          }
        } else {
          this.$swal({
            text: `Penggantian email akan menyebabkan pengiriman email aktivasi ulang. Lanjutkan penggantian email?`,
            type: "warning",
            showCancelButton: true,
            cancelButtonText: startCase("tidak"),
            confirmButtonText: startCase("ya")
          }).then(res => {
            if (res.value) {
              this.$axios
                .put(`klinik/pic`, {
                  id_user: parseInt(this.user_id),
                  nomor_telp: this.formData.telephone,
                  nama: this.formData.nama_pic,
                  email: this.formData.email,
                  klinik_id_pic: this.klinik_id,
                  klinik_id_pic_after:
                    typeof this.selectedKlinik === "object"
                      ? this.selectedKlinik.id
                      : this.klinik_id,
                  klinik_id: this.getKlinikId,
                  status: this.formData.is_active
                })
                .then(response => {
                  if (response.data.status === true) {
                    this.$swal({
                      text: `Email aktivasi berhasil dikirimkan`,
                      type: "success"
                    }).then(response => {
                      this.beingSubmit = true;
                      this.$router.push({
                        name: "pic-klinik-list"
                      });
                    });
                  } else if (response.data.status == "failed") {
                    this.$swal({
                      text: `Klinik sudah memiliki PIC`,
                      type: "warning",
                      confirmButtonText: "OK"
                    });
                  } else {
                    this.$swal({
                      text: `Data PIC gagal disimpan!`,
                      type: "warning"
                    });
                  }
                })
                .catch(error => {
                  this.$swal({
                    text: `Data PIC gagal disimpan!`,
                    type: "warning"
                  });
                });
            } else {
              next(false);
            }
          });
        }
      } catch (err) {
        this.$swal({
          text: `Data PIC gagal disimpan!`,
          type: "warning"
        });
      } finally {
        this.beingSubmit = false;
      }
    },
    async getKlinikData() {
      try {
        const res = await this.$axios.get(
          `klinik/pic/${this.user_id}?klinik_id=${this.klinik_id}`
        );
        const { data } = res.data;

        if (data == null) {
          this.$swal({
            text: `Data klinik tidak ada`,
            type: "warning"
          }).then(res => {
            this.beingSubmit = true;
            this.$router.push({
              name: "pic-klinik-list"
            });
          });
        } else {
          this.formData = data;
          this.selectedKlinik = data.klinik.nama;
          this.noIzinBefore = data.email;
          this.old_email = data.email;
          this.noHPBefore = data.telephone;
          this.accountStatus = data.is_active ? true : false;

          this.getFaskes();
        }
      } catch (err) {
        // console.log(err);
      }
    },
    async getFaskes() {
      try {
        const res = await this.$axios.get(
          `klinik/dropdown?klinik_id=${this.getKlinikId}`
        );
        const { data } = res.data;

        this.faskes = data.map(
          val => (
            this.klinik_id == val.id
              ? (this.selectedKlinik = val.nama_klinik)
              : null,
            {
              ...val,
              label: `${val.nama_klinik}`
            }
          )
        );
      } catch (error) {
        // console.error(error);
      }
    },
    cekValue: debounce(function(val) {
      if (this.old_email.toLowerCase() == val.toLowerCase()) {
        return (this.validasiEmail = true);
      }

      if (
        this.formData.email.match(
          /^([A-Za-z][A-Za-z0-9\-\.\_\+]*)\@([A-Za-z][A-Za-z0-9\-\_\+]*)(\.[A-Za-z][A-Za-z0-9\-\_\+]*)+$/
        ) == null
      ) {
        this.failedEmail = true;
      } else {
        this.failedEmail = this.loadEdit = false;
        this.$axios
          .post(`klinik/pic/email/cek`, {
            klinik_id: this.getKlinikId,
            email: this.formData.email,
            is_edit: true
          })
          .then(res => {
            if (val == this.noIzinBefore) {
              this.validasiNoIzin = true;
            } else if (res.data.status) {
              this.validasiNoIzin = true;
            } else if (!res.data.status) {
              this.validasiNoIzin = false;
            }
          });
      }
    }, 500),
    cekValueHP: debounce(function(val) {
      if (
        this.formData.telephone != "" &&
        this.formData.telephone != null &&
        this.formData.telephone.length > 9 &&
        this.formData.telephone.match(/[^0-9/]+/) == null
      ) {
        this.loadEdit = false;
        this.$axios
          .post(`klinik/pic/phone/cek`, {
            klinik_id: this.getKlinikId,
            telp: this.formData.telephone
          })
          .then(res => {
            if (val == this.noHPBefore) {
              this.validasiNoHP = true;
            } else if (res.data.status) {
              this.validasiNoHP = true;
            } else if (!res.data.status) {
              this.validasiNoHP = false;
            }
          });
      }
    }, 500)
  }
};
</script>
<style lang="scss">
.custom-dropzone {
  .dz-message {
    padding: 10rem 1rem;
  }
}
</style>
